import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components
import Navbar from "./components/Navbar";
import ImageSlider from "./components/ImageSlider";
import About from "./pages/About";
import Partners from "./pages/Partners";
import Footer from "./components/Footer";

// Main Pages
import Careers from "./pages/Careers";
import ContactUs from "./pages/ContactUs";
import RemoteSensing from "./pages/RemoteSensing";
import Form from "./pages/Form"; // Job Application Form

// Advisory Pages
import CloudOneMigration from "./pages/CloudOneMigration";
import GovCloudMigration from "./pages/GovCloudMigration";
import CloudReadiness from "./pages/CloudReadiness";
import ApplicationCandidacy from "./pages/ApplicationCandidacy";
import FoundationAssessment from "./pages/FoundationAssessment";
import WorkloadReadiness from "./pages/WorkloadReadiness";

// Security Pages
import CloudSecurity from "./pages/CloudSecurity";
import DataSecurity from "./pages/DataSecurity";
import Compliance from "./pages/Compliance";

// Product Pages
import ProductA from "./pages/ProductA";
import ProductB from "./pages/ProductB";
import ProductC from "./pages/ProductC";

// Resources Pages
// Tutorial Pages
import TuxedoTutorial from "./pages/TuxedoTutorial";
import Tibco from "./pages/Tibco";
import MQSeries from "./pages/MQSeries";
import HPNonStopTuxedo from "./pages/HPNonStopTuxedo";
import EGate from "./pages/EGate";

// Case Studies Pages
import CustomerCaseStudies from "./pages/CustomerCaseStudies";
import EAIVisionCaseStudies from "./pages/EAIVisionCaseStudies";
import EMR from"./pages/EMR"
import TechnologyIdeas from "./pages/TechnologyIdeas";

// Support & Downloads
import SupportDownloads from "./pages/SupportDownloads";

function App() {
  return (
    <Router>
      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        {/* Navbar */}
        <Navbar />

        {/* Page Content */}
        <div style={{ flex: 1 }}>
          <Routes>
            {/* Homepage */}
            <Route
              path="/"
              element={
                <>
                  <ImageSlider />
                  <About />
                  <Partners />
                </>
              }
            />

            {/* Static Pages */}
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/remote-sensing" element={<RemoteSensing />} />

            {/* Job Application Form */}
            <Route path="/apply" element={<Form />} />

            {/* Advisory Pages */}
            <Route path="/cloud-one-migration" element={<CloudOneMigration />} />
            <Route path="/govcloud-migration" element={<GovCloudMigration />} />
            <Route path="/cloud-readiness" element={<CloudReadiness />} />
            <Route path="/application-candidacy" element={<ApplicationCandidacy />} />
            <Route path="/foundation-assessment" element={<FoundationAssessment />} />
            <Route path="/workload-readiness" element={<WorkloadReadiness />} />

            {/* Security Pages */}
            <Route path="/cloud-security" element={<CloudSecurity />} />
            <Route path="/data-security" element={<DataSecurity />} />
            <Route path="/compliance" element={<Compliance />} />

            {/* Product Pages */}
            <Route path="/product-a" element={<ProductA />} />
            <Route path="/product-b" element={<ProductB />} />
            <Route path="/product-c" element={<ProductC />} />

            {/* Tutorials */}
            <Route path="/tutorials/tuxedo-tutorial" element={<TuxedoTutorial />} />
            <Route path="/tutorials/tibco" element={<Tibco />} />
            <Route path="/tutorials/mq-series" element={<MQSeries />} />
            <Route path="/tutorials/hp-nNonStop-tuxedo" element={<HPNonStopTuxedo />} />
            <Route path="/tutorials/E*Gate" element={<EGate />} />

            {/* Case Studies */}
            <Route path="/case-studies/customer-case-studies" element={<CustomerCaseStudies />} />
            <Route path="/case-studies/eaivision-case-studies" element={<EAIVisionCaseStudies />} />
            <Route path="/emr" element={<EMR />} /> {/* <- Detail page */}
            <Route path="/case-studies/technology-ideas" element={<TechnologyIdeas />} />

            {/* Support & Downloads */}
            <Route path="/support-downloads" element={<SupportDownloads />} />
          </Routes>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
